import React, { useEffect, useState } from "react";
import bookUrl from "../../../../api/bookUrl";

interface Column {
  id: "name" | "role" | "actions";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "name", label: "Name", minWidth: 170 },
  {
    id: "role",
    label: "Description",
    minWidth: 170,
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "right",
  },
];

interface Data {
  _id?: string;
  name: string;
  role: string;
}

function createData(name: string, role: string, _id?: string): Data {
  return { name, role, _id };
}


function BookTreatment() {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [raw, setraw] = useState<Data[]>([]);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    treatment: "",
    description: "",
  });

  const handleClose = () => {
    setisModalOpen(false);
    setEditingId(null);
    setFormData({
      treatment: "",
      description: "",
    });
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const fetchData = () => {
    bookUrl
      .get("/bookingadmin/treatment/findBookingTreatment")
      .then((response) => {
        const formattedRows = response.data.data.map((item: any) =>
          createData(item.name, item.description, item._id)
        );
        setraw(formattedRows);
      })
      .catch(console.error)
      .finally(() => {});
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (editingId) {
      // Update existing treatment
      bookUrl
        .patch("/bookingadmin/treatment/updateBookingTreatment", {
          name: formData.treatment,
          description: formData.description,
        }, {
          headers: {
            treatmentid: editingId,
          },
        })
        .then((response) => {
          fetchData();
          handleClose();
        })
        .catch(console.error)
        .finally(() => {});
    } else {
      // Add new treatment
    bookUrl
      .post("/bookingadmin/treatment/addBookingTreatment", formData)
      .then((response) => {
          fetchData();
        handleClose();
      })
      .catch(console.error)
      .finally(() => {});
    }
  };

  const handleEdit = (row: Data) => {
    setEditingId(row._id || null);
    setFormData({
      treatment: row.name,
      description: row.role,
    });
    setisModalOpen(true);
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClick = () => {
    setisModalOpen(true);
  };
  return (
    <div className="bg-white max-h-full rounded-md">
      <div className="flex flex-row justify-between items-center w-full p-4 mt-auto gap-4">
        <h3 className="text-lg font-semibold">book teatment</h3>
        <button 
          onClick={handleClick} 
          className="bg-[#174d7a] text-white px-4 py-2 rounded hover:bg-[#1a5a8a] transition-colors"
        >
          ADD
        </button>
      </div>
      <div className="w-full overflow-hidden bg-white rounded shadow-sm">
        <div className="h-[calc(100vh-240px)] overflow-auto">
          <table className="w-full border-collapse">
            <thead className="sticky top-0 bg-[rgb(250,250,250)] z-10">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.id}
                    className={`py-3 px-4 text-left text-xs font-bold uppercase text-[var(--text-color)] border-b border-[rgb(240,240,240)] ${column.align === "right" ? "text-right" : ""}`}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {raw
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, i) => {
                  return (
                    <tr 
                      key={row._id || i} 
                      className="hover:bg-gray-50 transition-colors"
                      role="checkbox"
                      tabIndex={-1}
                    >
                      {columns.map((column) => {
                        if (column.id === "actions") {
                          return (
                            <td 
                              key={column.id} 
                              className={`py-3 px-4 text-sm text-[var(--text-color)] border-b border-[rgb(240,240,240)] ${column.align === "right" ? "text-right" : ""}`}
                            >
                              <button
                                onClick={() => handleEdit(row)}
                                className="text-[#174d7a] hover:text-[#1a5a8a] transition-colors"
                                title="Edit"
                              >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                            </td>
                          );
                        }
                        const value = row[column.id];
                        return (
                          <td 
                            key={column.id} 
                            className={`py-3 px-4 text-sm text-[var(--text-color)] border-b border-[rgb(240,240,240)] ${column.align === "right" ? "text-right" : ""}`}
                          >
                            {value}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between px-4 py-3 border-t border-[rgb(240,240,240)]">
          <div className="flex items-center gap-2">
            <span className="text-sm text-[var(--text-color)]">Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handleChangeRowsPerPage(e)}
              className="border border-gray-300 rounded px-2 py-1 text-sm bg-white text-[var(--text-color)]"
            >
              {[10, 25, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-2 text-sm text-[var(--text-color)]">
            <span>
              {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, raw.length)} of {raw.length}
            </span>
            <div className="flex gap-1">
              <button
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 0}
                className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Previous
              </button>
              <button
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(raw.length / rowsPerPage) - 1}
                className="px-3 py-1 border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                handleClose();
              }
            }}
          />
          <div className="fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 flex flex-col">
            <div className="flex flex-row justify-between items-center p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-[var(--text-color)]">
                {editingId ? "Edit Treatment" : "Add Treatment"}
              </h2>
              <button
                onClick={handleClose}
                className="text-gray-600 hover:text-gray-800 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={onSubmit} className="flex flex-col flex-1">
              <div className="flex flex-col gap-4 p-4 flex-1">
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-[var(--lable-color)]">treatment</label>
                  <input
                    type="text"
                    name="treatment"
                    value={formData.treatment}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-[var(--input-color)] text-[var(--text-color)] focus:outline-none focus:ring-2 focus:ring-[#174d7a] focus:border-transparent"
                    placeholder="Enter treatment"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-medium text-[var(--lable-color)]">description</label>
                  <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md bg-[var(--input-color)] text-[var(--text-color)] focus:outline-none focus:ring-2 focus:ring-[#174d7a] focus:border-transparent min-h-[100px] resize-y"
                    placeholder="Enter description"
                  />
                </div>
              </div>
              <div className="flex flex-row justify-end items-center gap-4 p-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                >
                  cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-[#174d7a] text-white rounded hover:bg-[#1a5a8a] transition-colors"
                >
                  {editingId ? "Update" : "Add"}
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
}

export default BookTreatment;
